"use client";

import { useMemo } from "react";
import NextImage from "../NextImage";
import { Ecosystem } from "@/src/features/api/openData";

const InitEcosystemData = [
  {
    id: "sonic",
    name: "Sonic",
    logo: "https://img.cryptorank.io/coins/sonic1734443301365.png",
  },
  {
    id: "berachain",
    name: "Berachain",
    logo: "https://img.cryptorank.io/coins/berachain1738853075308.png",
  },
];

interface EcosystemGridProps {
  onItemClick?: ({
    keyword,
    ecosystem,
  }: {
    keyword?: string;
    ecosystem?: string;
  }) => void;
  data?: Ecosystem[];
  loading?: boolean;
}

export const EcosystemGrid = ({
  onItemClick,
  data,
  loading,
}: EcosystemGridProps) => {
  const ecosystemData = useMemo(() => {
    // 判断数组中是否有InitEcosystemData中的数据（根据id判断），如果没有则依次将data末尾的数据使用InitEcosystemData的数据进行替换
    if (!data || data.length === 0) {
      return [];
    }
    // 找出InitEcosystemData中哪些id在data中不存在
    const missing = InitEcosystemData.filter(
      (initItem) =>
        !data.some((item, index) => item.id === initItem.id && index < 10),
    );
    if (missing.length === 0) {
      return data;
    }
    // 复制data
    const newData = [...data];
    // 从末尾依次替换
    for (let i = 0; i < missing.length && i < newData.length; i++) {
      newData[newData.length - 1 - i] = missing[i];
    }
    return newData;
  }, [data]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {loading &&
        data?.length === 0 &&
        Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className="flex items-center gap-2 p-3 rounded-2 bg-background_white_overlay5"
          >
            <div className="h-8 w-8 rounded-full bg-background_white_overlay10 animate-pulse" />
            <div className="h-4 w-20 rounded-1 bg-background_white_overlay10 animate-pulse" />
          </div>
        ))}
      {ecosystemData?.map((ecosystem, index) => (
        <div
          data-openreplay-label="HomeQuestionCard · EcosystemGrid · div"
          key={`${ecosystem.id}-${index}`}
          className="flex items-center gap-2 p-3 rounded-2 cursor-pointer bg-background_white_overlay5 hover:bg-background_white_overlay10"
          onClick={() => {
            onItemClick?.({
              ecosystem: ecosystem.name,
              keyword: `ecosystem_chat_id#${ecosystem.id}`,
            });
          }}
        >
          <NextImage
            src={ecosystem.logo || "/assets/images/chat_normal.webp"}
            alt={ecosystem.name || "Ecosystem"}
            width={32}
            height={32}
          />
          <span className="body_medium_l text-content_primary">
            {ecosystem.name}
          </span>
        </div>
      ))}
    </div>
  );
};
